import { Check, AlertTriangle } from "lucide-react";

export const ValidationBadgeForecastDemand = ({ 
    valid, 
    value 
}) => {
    return (
        <span
            className={`inline-flex items-center gap-1 text-[12px] font-medium px-1.5 py-0.5 rounded-[4px] ${
                valid ? "text-emerald-700 bg-emerald-50" : "text-red-600 bg-red-50"
            }`}
        >
            {valid ? <Check size={11} /> : <AlertTriangle size={11} />}
            {value}
        </span>
    );
}
